import React from 'react';
import { Tag } from '@ontruck/orc';
import styled from 'styled-components';

const t = {
  LHE: 'LHE',
};

const StyledTag = styled(Tag)`
  color: var(--grey100);
  background-color: var(--greenKiwiText);
`;

const OrderLHExpressInfo = ({ isLHExpress }) => {
  return (
    isLHExpress && (
      <StyledTag mLeft="XS" weight="bold">
        {t['LHE']}
      </StyledTag>
    )
  );
};

export default OrderLHExpressInfo;
